import React from "react";

const Comment = ({ item, currentUser, deleteComment, mention, isLast }) => {
  return (
    <div className="comment-item">
      <div
        className="profile-logo"
        style={{ backgroundImage: `url(${item.user.photoUrl})` }}
      ></div>
      <div className="comment-desc">
        <div className="username">{item.user.username}</div>
        <div className="description">{item.comment}</div>

        <div className="comment-interactions">
          <div className="left">
            <span className="answer-comment" onClick={() => mention(item.user)}>
              Cevapla
            </span>
          </div>
          <div className="right">
            {item?.user.id == currentUser?.user.id ? (
              <button
                className="btn btn-comment"
                onClick={() => {
                  deleteComment(item.id);
                }}
              >
                Sil
              </button>
            ) : null}
          </div>
        </div>
        {!isLast ? <div className="seperate small"></div> : null}
      </div>
    </div>
  );
};

export default Comment;
